import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';
import { languageLevels } from '../../shared/constants';
//import { setCandidateProfileImage } from '../actions';

/**
* @desc reducer for candidate profile
* @version
* @author Lakshmikanth 
* @return updated state
*/
const initialState = {
  profileTabKey: "highlights",
  profileInfo: []  
};

const setProfile = ( state = initialState , action ) => {
  const profileInfo = {...action.profileInfo};

  if(profileInfo.languages && profileInfo.languages.length > 0) {
    profileInfo.languages.map((lang) => { lang['stars'] = languageLevels[lang.skill.toLowerCase()] });
  }  
  return updateObject( state, { profileInfo : profileInfo } );
};

const clearReduxState = ( state = initialState , action ) => {
  return updateObject( state, initialState );   
};

const setCandidateProfileImage = (state = initialState , action) => {
  const profileInfo = {...state.profileInfo};
  profileInfo.s3SignedUrl = action.s3SignedUrl;
  profileInfo.candidate_image = action.candidateImage;
  return updateObject( state, { profileInfo : profileInfo } ); 

};

const updateCandidateEditStatus = (state = initialState , action) => {
  const profileInfo = {...state.profileInfo};
  profileInfo.candidate_edit_status = action.editStatus;
  return updateObject( state, { profileInfo : profileInfo } ); 
};


const updateCandidateProfileEdit = (state = initialState , action) => {
  const profileInfo = {...state.profileInfo};
  profileInfo.candidate_name = action.candidateName;
  profileInfo.initials = action.candidateInitials;
  profileInfo.candidate_email = action.candidateEmail;
  profileInfo.notice_period = action.candidateNoticeperiod;
  profileInfo.job_type = action.candidateJobtype;
  return updateObject( state, { profileInfo : profileInfo } ); 
};
const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SET_PROFILE_DETAILS: 
      return setProfile(state, action);  
    case actionTypes.CLEAR_TALENT_POOL:
    case actionTypes.COGNITO_LOGOUT:
      return clearReduxState(state,action);   
    case actionTypes.SET_CANDIDATE_PROFILE_IMAGE:  
      return setCandidateProfileImage(state,action);
    case actionTypes.SET_CANDIDATE_EDIT_STATUS:
      return updateCandidateEditStatus(state,action); 
      case actionTypes.SET_CANDIDATE_PROFILE_EDIT:
    return updateCandidateProfileEdit(state,action);
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/candidateProfile.js